export default "__VITE_ASSET__5545d534__"